const { debounce } = window.BAO.Utils
const KeenSlider = window.KeenSlider

const { setInitialised, useAutoplay } = window.BAO.Carousel.plugins

class AnnouncementCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return

    this.checkSetupCarousel()
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.destroyCarousel()
  }

  setupListeners () {
    this.listeners.add(
      window,
      'resize',
      debounce(() => {
        this.checkSetupCarousel()
      }, 500),
    )
  }

  destroyCarousel () {
    if (!this.carousel) return

    this.carousel.destroy()
    this.carousel = null
    this.els?.slides?.element?.removeAttribute('data-initialised')
  }

  checkSetupCarousel () {
    const slideCount = this.els?.slide?.elements?.length || 0

    if (window.BAO.MediaBreakpoints.isXsViewport === true && slideCount > 1) {
      if (!this.carousel) {
        this.carousel = this.setupCarousel()
      }

      return
    }

    this.destroyCarousel()
  }

  setupCarousel () {
    const speed = Number(this.getAttribute('data-announcement-carousel-speed')) || 4
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const plugins = [setInitialised()]

    if (reduceMotion === false) {
      plugins.push(useAutoplay(speed, { pauseOnHover: true }))
    }

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: reduceMotion === false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        defaultAnimation: {
          duration: reduceMotion === true ? 0 : 400,
        },
      },
      plugins,
    )
  }
}

if (!customElements.get('announcement-carousel')) {
  customElements.define('announcement-carousel', AnnouncementCarousel)
}
